module.exports = __webpack_public_path__ + "static/img/download_icon.f3ca601.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/download_icon.png
// module id = VKfO
// module chunks = 10